import { render, staticRenderFns } from "./DetailsMessagesGrouped.vue?vue&type=template&id=861a9bb0"
import script from "./DetailsMessagesGrouped.vue?vue&type=script&lang=ts"
export * from "./DetailsMessagesGrouped.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports